type BrandWordmarkProps = {
  className?: string;
  /** Accessible label for the brand mark. */
  label?: string;
};

/** Text wordmark for nav headers - theme-aware via CSS tokens. */
export function BrandWordmark({
  className = '',
  label = 'Takshify™ - The Digital Takshashila',
}: BrandWordmarkProps) {
  return (
    <span className={`brand-wordmark ${className}`.trim()} role="img" aria-label={label}>
      <span className="brand-wordmark-name" aria-hidden>
        <span className="brand-wordmark-takshi">TAKSHI</span>
        <span className="brand-wordmark-fy">FY</span>
        <span className="brand-wordmark-tm">™</span>
      </span>
      <span className="brand-wordmark-tagline" aria-hidden>
        <span className="brand-wordmark-rule" />
        <span className="brand-wordmark-tagline-text">THE DIGITAL TAKSHASHILA</span>
        <span className="brand-wordmark-rule" />
      </span>
    </span>
  );
}
